import { render } from "./video-content.vue?vue&type=template&id=a707d42c&scoped=true"
import script from "./video-content.vue?vue&type=script&lang=js"
export * from "./video-content.vue?vue&type=script&lang=js"

import "./video-content.vue?vue&type=style&index=0&id=a707d42c&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a707d42c"]])

export default __exports__